import { render, staticRenderFns } from "./Gross.vue?vue&type=template&id=0532634b&"
import script from "./Gross.vue?vue&type=script&lang=js&"
export * from "./Gross.vue?vue&type=script&lang=js&"
import style0 from "./Gross.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports